export enum OrderItemButtonType {
  REOPEN = 'reopen',
  SETUP = 'setup',
  NEXT = 'next',
  MANUAL_CUTTING = 'manualCutting',
  MANUAL_SORTING = 'manualSorting'
}
